// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Leistungen from './pages/Leistungen';
import Kontakt from './pages/Kontakt';
import Datenschutz from './pages/Datenschutz';
import Gallery from './pages/Gallery';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// --- ScrollToTop Component ---
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto', // or 'smooth' if you prefer smooth scroll
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      {/* Ensures every route change starts from the top */}
      <ScrollToTop />

      <div
        style={{
          backgroundColor: '#000000',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Header />

        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/galerie" element={<Gallery />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;